module.exports = __webpack_public_path__ + "static/media/MondaySpecial2x.af6969b3.png";